import type { VenueWeekdayHours, Weekday } from './operatingHours';

export type EditableWeekdayHours = {
  weekday: Weekday;
  openTime: string;
  closeTime: string;
  closed: boolean;
};

const WEEKDAYS: Weekday[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY',
];

export function emptyEditableWeekdayHours(): EditableWeekdayHours[] {
  return WEEKDAYS.map((weekday) => ({
    weekday,
    openTime: '',
    closeTime: '',
    closed: false,
  }));
}

export function toEditableWeekdayHours(entry: VenueWeekdayHours): EditableWeekdayHours {
  return {
    weekday: entry.weekday,
    openTime: entry.openTime ?? '',
    closeTime: entry.closeTime ?? '',
    closed: entry.openTime === null && entry.closeTime === null,
  };
}

export function toRequestWeekdayHours(row: EditableWeekdayHours): VenueWeekdayHours {
  return {
    weekday: row.weekday,
    openTime: row.closed ? null : row.openTime,
    closeTime: row.closed ? null : row.closeTime,
  };
}

export function validateEditableWeekdayHours(
  weekdayHours: EditableWeekdayHours[],
): 'missing_interval' | 'invalid_interval' | null {
  for (const row of weekdayHours) {
    if (row.closed) continue;
    if (!row.openTime || !row.closeTime) return 'missing_interval';
    if (row.openTime >= row.closeTime) return 'invalid_interval';
  }
  return null;
}
